import ResponsiveHeader from '../components/DataTable/ResponsiveHeader';

const DATA_TITLE = 'data-title';
const rootData = document.getElementById('root').dataset || {};

/**
 * Config for vendors table
 */
export default {
    url: `/bloodstock/sales/catalogues/${rootData.venueid}/${rootData.salesdate}/vendors/data.json`,
    columns: [
        {
            columnName: 'vendor_name',
            displayName: 'Vendor',
            headerDataAttrs: {
                [DATA_TITLE]: 'vendor'
            }
        },
        {
            columnName: 'no_lots',
            customHeader: {
                component: ResponsiveHeader,
                options: {
                    displayName: [
                        {
                            className: 'hidden-sm-up',
                            displayName: '#'
                        },
                        {
                            className: 'hidden-xs-down hidden-md-up',
                            displayName: 'Lots'
                        },
                        {
                            className: 'hidden-sm-down',
                            displayName: 'No.Lots'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'lots'
            }
        },
        {
            columnName: 'no_colts',
            customHeader: {
                component: ResponsiveHeader,
                options: {
                    displayName: [
                        {
                            className: 'hidden-sm-up',
                            displayName: 'Colts'
                        },
                        {
                            className: 'hidden-xs-down',
                            displayName: 'No.Colts'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'no-colts'
            }
        },
        {
            columnName: 'no_fillies',
            customHeader: {
                component: ResponsiveHeader,
                options: {
                    displayName: [
                        {
                            className: 'hidden-sm-up',
                            displayName: 'Fillies'
                        },
                        {
                            className: 'hidden-xs-down',
                            displayName: 'No.Fillies'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'no-fillies'
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./src/js/config/vendorsTable.js